import { replaceEqualDeep } from '@tanstack/vue-query'

// O instante pertence ao snapshot; dataUpdatedAt também controla o frescor da query.
const sincronizacoes = new WeakMap<readonly unknown[], number>()

export const criarSnapshotCatalogo = <T>(itens: readonly T[], sincronizadoEm: number): readonly T[] => {
  const snapshot = [...itens]
  sincronizacoes.set(snapshot, sincronizadoEm)
  return snapshot
}

export const obterSincronizacaoCatalogo = (snapshot: unknown): number | null => (
  Array.isArray(snapshot) ? sincronizacoes.get(snapshot) ?? null : null
)

export const compartilharSnapshotCatalogo = (anterior: unknown, novo: unknown): unknown => {
  const sincronizadoEm = obterSincronizacaoCatalogo(novo)
  const snapshot: unknown = replaceEqualDeep(anterior, novo)
  if (Array.isArray(snapshot)) {
    if (sincronizadoEm === null) sincronizacoes.delete(snapshot)
    else sincronizacoes.set(snapshot, sincronizadoEm)
  }
  return snapshot
}
